import {
    regist, login
} from '@/api/user'
import {
    dealForm
} from '@/utils/index';
import {
    Toast
} from 'vant';
import { getToken } from '@/utils/auth'


export default {
    name: 'sign',
    data() {
        return {
            formSignIn: {
                username: '',
                password: '',
            },
            formSignUp: {
                realname: '',
                username: '',
                type: '0',
                school: '',
                address: '',
                reference: '',
                password: '',
            },
            repeatPWD: '',
            active: 0,
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, 
            radio: '1',
            tabs: [{
                    title: 'SIGN IN 登录',
                    
                },
                {
                    title: 'SIGN UP 注册',
                },
            ]
        }
    },

    methods: {
        onChange() {
            // this.formSignIn.username = '';
            // this.formSignIn.password = '';
            // this.formSignUp.name = '';
            // this.formSignUp.phone = '';
            // this.formSignUp.address = '';
            // this.formSignUp.referral = null;
            // this.formSignUp.password = null;
        },
        onSignupSubmit(values) {
            const that = this;
            if(that.formSignUp.password != that.repeatPWD) {
                Toast.fail({
                    message: '两次输入的密码不一致！',
                    forbidClick: true,
                    onClose: () => {
                        that.formSignUp.password = ''
                        that.repeatPWD = ''
                    }
                })
                return false
            }
            let fd = dealForm(that.formSignUp);
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            })

            regist(fd).then(res => {
                console.log(res);
                    Toast.clear()
                    Toast.success({
                        message: res.msg,
                        forbidClick: true,
                        // duration: 1000,
                        onClose: () => {

                                // that.$router.replace('/')
                                that.formSignIn.username = that.formSignIn.username
                                that.formSignIn.password = that.formSignUp.password
                                that.active = 0
                            
                        }
                    });
                
            }).catch(rej => {
                console.log(rej);
                Toast.clear()
                Toast.fail({
                    message: rej.msg,
                    forbidClick: true,
                    onClose: () => {
                        that.formSignUp.username = ''
                        that.formSignUp.password = ''
                        that.repeatPWD = ''
                    }
                });
            })
        },

        onLoginSubmit(values) {
            const that = this;
            let fd = dealForm(that.formSignIn)
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            })

            login(fd).then(res => {
                Toast.clear()
                Toast.success({
                    message: res.msg,
                    forbidClick: true,
                    // duration: 1000,
                    onClose: () => {
                        if(res.state == 200) {
                            if(getToken()) {
                                that.$global.realname = res.data.realname
                                that.$global.type = res.data.type
                                that.$router.replace('/')
                                // that.$router.replace('/')
            
                            }
                            
                        }
                        
                    }
                });


                
            }).catch(rej => {
                console.log('rej', rej);
                Toast.clear()
                Toast.fail({
                    message: rej.msg,
                    forbidClick: true,
                    onClose: () => {
                        that.formSignIn.password = ''
                    }
                });
            })
        },



        // 校验函数返回 true 表示校验通过，false 表示不通过
        validator(val) {
            return /1\d{10}/.test(val);
        },
        // 异步校验函数返回 Promise
        asyncValidator(val) {
            return new Promise((resolve) => {
                Toast.loading('验证中...');

                setTimeout(() => {
                    Toast.clear();
                    resolve(/\d{6}/.test(val));
                }, 1000);
            });
        },
        onFailed(errorInfo) {
            console.log('failed', errorInfo);
        },

    },

    mounted() {

        let fd = dealForm(this.form)


    }
}